import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { MenuItem } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { HasPermissionDirective } from '../../../../../directives/has-permission.directive';
import { DateNavigationService } from '../../../../../services/date-navigation.service';
import { MenuItemWithIcon } from '../../../../../types/menu.interface';
import { CesActionMenuComponent } from '../../../../ui/ces-action-menu/ces-action-menu.component';
import { CesAssetBreadcrumbComponent } from '../../../../ui/ces-asset-breadcrumb/ces-asset-breadcrumb.component';
import { CesButtonSecondaryComponent } from '../../../../ui/ces-buttons/ces-button-secondary.component';
import { CesButtonComponent } from '../../../../ui/ces-buttons/ces-button.component';
import { CesDateNavigationComponent } from '../../../../ui/ces-date-navigation/ces-date-navigation.component';
import { ExpandableDescriptionComponent } from '../../../../ui/expandable-description/expandable-description.component';

@Component({
  selector: 'app-graph-header',
  imports: [
    FormsModule,
    TranslocoModule,
    TagModule,
    CheckboxModule,
    CesAssetBreadcrumbComponent,
    CesButtonComponent,
    CesButtonSecondaryComponent,
    CesActionMenuComponent,
    ExpandableDescriptionComponent,
    CesDateNavigationComponent,
    HasPermissionDirective,
  ],
  templateUrl: './graph-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraphHeaderComponent {
  readonly breadcrumbTrail = input.required<MenuItem[]>();
  readonly liveRegionMessage = input.required<string>();
  readonly graphName = input.required<string>();
  readonly graphTypeLabel = input.required<string>();
  readonly graphDescription = input<string | null>(null);
  readonly menuItems = input.required<MenuItemWithIcon[]>();
  readonly showDateNavigation = input<boolean>(false);
  readonly showRefreshControls = input<boolean>(false);
  readonly dateNav = input.required<DateNavigationService>();
  readonly canRefresh = input<boolean>(false);
  readonly autoRefresh = input<boolean>(false);
  readonly canSave = input<boolean>(true);
  readonly assetId = input.required<number>();

  readonly save = output<void>();
  readonly refresh = output<void>();
  readonly autoRefreshChange = output<boolean>();
}
